import { useContext, useEffect } from 'react';
import { StyledAreaChart } from './AreaChart.style';
import MetricsInspectionContext from '../../state/context';
import CustomWidget from '../../../CustomReport/Widgets/CustomWidget/CustomWidget';
import useFilters from './useFilters';
import useReport from './useReport';
import useCustomDashboardMetrics from '../../../CustomReport/custom-hooks/useCustomDashboardMetrics';
import usePeriods from '../../state/hooks/usePeriods';
import useChartEvents from './useChartEvents';
const AreaChart = () => {
  const {
    state: { widget }
  } = useContext(MetricsInspectionContext);

  const filters = useFilters();
  const report = useReport();
  const { metrics, metricsTotal, loadingMetrics, fetchNewMetricsData } =
    useCustomDashboardMetrics({
      report,
      filters,
      isInspection: true
    });

  const { lastPeriod } = usePeriods();
  const { onAreaSelect, onPointHover, onPointClick } = useChartEvents();

  useEffect(() => {
    fetchNewMetricsData();
  }, [lastPeriod.before, lastPeriod.after]);

  return (
    <StyledAreaChart>
      <CustomWidget
        graph={widget}
        filters={filters}
        metrics={metrics}
        metricsTotal={metricsTotal}
        loadingMetrics={loadingMetrics}
        events={{ onAreaSelect, onPointHover, onPointClick }}
        isInspection
        shouldHideTitle
        shouldHideCalcStrategy
        shouldHideBenchmark
        shouldHideClickableMessage={true}
        isEditingEnabled={false}
        border='0'
        height='90%'
        width='100%'
      />
    </StyledAreaChart>
  );
};

export default AreaChart;
